module.exports = __webpack_public_path__ + "static/media/success-light.00e92346.svg";